export const SET_CATEGORIES_STATE = 'SET_CATEGORIES_STATE'
